import { render, staticRenderFns } from "./SearchAiChat.vue?vue&type=template&id=2bc6b47a&scoped=true&"
import script from "./SearchAiChat.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchAiChat.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SearchAiChat.vue?vue&type=style&index=0&id=2bc6b47a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6b47a",
  null
  
)

export default component.exports